import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import Header from 'shared/components/Header';
import Footer from 'shared/components/Footer';
import ConsentBanner from 'shared/components/ConsentBanner';

const GoogleOneTap = dynamic(
    () => import('shared/components/AuthModal/section/GoogleOneTap'),
    {
        ssr: false
    }
);

const MainScript = dynamic(() => import('shared/components/main'), {
    ssr: false
});

/**
 * Default layout used across site, includes web chrome i.e header, footer etc
 */
export const Layout: React.FC = ({ children }) => (
    <>
        <Header />
        <ConsentBanner />
        <MainScript />
        {children}
        <GoogleOneTap />
        <Footer />
    </>
);

/**
 * Default getLayout function used if not defined on the Page component.
 * @see {Layout}
 */
export const getWebChromeLayout = (page: ReactElement): ReactElement => (
    <Layout>{page}</Layout>
);
